import React from "react";
import {useSelector} from "react-redux";
import {Button, Typography, Stack} from "@mui/material";
import Grid from "@mui/material/Grid2";
import BackButton from "./Common/BackButton";
import {useTranslation} from "react-i18next";
import {RootState} from '../../Redux'
import {SelfServiceSettingsType} from '../../interfaces'

export function SelectDriveIn({ onSelect }) {
    const { t } = useTranslation()
    const settings: SelfServiceSettingsType = useSelector((state: RootState) => state.ui.settings?.selfService ?? {});


    return (<Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={6} className={'pageMainContainer'}>
        <Grid size="grow">
        </Grid>
        <Grid>
            <Stack spacing={1} alignItems="center">
                <Typography variant="subtitle1">
                    {settings.driveInAvailable ? t('selfService.selectDriveInHelpText') : t('selfService.selectCheckInHelpText')}
                </Typography>
                <Button
                    fullWidth
                    variant="contained"
                    style={{width: 600, maxWidth: '90vw'}}
                    onClick={() => onSelect(true)}
                >
                    {t('selfService.selectDriveIn')}
                </Button>
            </Stack>
        </Grid>
        {settings.bookingAvailable ? <Grid>
            <Stack spacing={1} alignItems="center">
                <Typography variant="subtitle1" >
                    {t('selfService.selectOtherTimeHelpText')}
                </Typography>
                <Button
                    fullWidth
                    variant="contained"
                    style={{width: 600, maxWidth: '90vw'}}
                    onClick={() => onSelect(false)}
                >
                    {t('selfService.selectOtherTime')}
                </Button>
            </Stack>
        </Grid> : null}
        <Grid size="grow">
        </Grid>
        <Grid className="footerButtons">
            <BackButton onBack={() => window.location.reload()} />
        </Grid>
    </Grid>);
}
